import type { ReadonlyDeep } from 'type-fest';

import { MissionKindEnum } from '@e-socna/data-layer';
import type {
  CodingConfigUnionInput,
  Id,
  MissionInput,
} from '@e-socna/data-layer';

import { missionForm2ApiMapper } from './mission.form2api.mapper';
import type { MissionForm_Mission } from '../fragments/mission.fragment';
import type { SubMissionTurnLists } from '../hooks/useSubMissionTurnLists.hook';

interface CollaborationReferences {
  readonly collaborationWorkflowId: Id;
  readonly codingConfig: CodingConfigUnionInput;
}

const buildCollaborationInput = (
  mission: ReadonlyDeep<MissionInput>,
  { collaborationWorkflowId, codingConfig }: Readonly<CollaborationReferences>,
): ReadonlyDeep<MissionInput> => ({
  kind: MissionKindEnum.Composite,
  folderId: mission.folderId,
  title: mission.title,
  internalActors: mission.internalActors,
  externalActors: mission.externalActors,
  address: mission.address,
  isConfidential: mission.isConfidential,
  businessCreatorId: mission.businessCreatorId,
  businessCreationDate: mission.businessCreationDate,
  workflowId: collaborationWorkflowId,
  codingConfig,
});

// The form values carry the lists of the collaboration; a turned sub-mission
// takes its own lists in it.
export function collaborationTurnForm2ApiMapper(
  mission: ReadonlyDeep<MissionForm_Mission>,
  references: Readonly<CollaborationReferences>,
  subMissionLists?: SubMissionTurnLists,
) {
  const collaborationSource = missionForm2ApiMapper(mission);
  const missionUpdate = {
    ...(subMissionLists
      ? missionForm2ApiMapper({ ...mission, ...subMissionLists })
      : collaborationSource),
    compositeMissionId: null,
  };

  return {
    collaboration: buildCollaborationInput(collaborationSource, references),
    missionUpdate,
  };
}
